import { Injectable } from '@angular/core';
import { map, Observable, of, Subject, takeUntil } from 'rxjs';
import { HttpService } from '../http/http.service';
import { LodashService } from '../lodash/lodash.service';
import { ApiMethod, Endpoints } from '../utils/constants';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Injectable({
  providedIn: 'root',
})
export class ReconiliationService {
  staticText: any = TranslationService.staticTextData;
  formConfig = [
    {
      title: ``,
      key: '',
      sectionType: 'root',
      columns: 2,
      meta: { isEmptyCheck: true, hideSectionTitle: true },
      fields: [],
    },
  ];
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly _http: HttpService, private readonly _lodash: LodashService) {}

  private buildEndpoint(base: string, param?: any): string {
    return param ? `${base}${param}` : base;
  }

  private makeRequest(endpoint: any, method: ApiMethod): Observable<any> {
    return this._http.requestCall(endpoint, method).pipe(
      map((e: any) => e),
      takeUntil(this.destroy$)
    );
  }

  getReconiliationList(param?: any): Observable<any> {
    const endpoint = this.buildEndpoint(Endpoints.GET_RECONCILIATION, param);
    return this.makeRequest(endpoint, ApiMethod.GET);
  }

  getReconiliationById(id: any): Observable<any> {
    const endpoint = this.buildEndpoint(`${Endpoints.GET_RECONCILIATION}${id}/`);
    return this.makeRequest(endpoint, ApiMethod.GET);
  }

  getNextStatus(id: any) {
    let endpoint: any = Endpoints.GET_NEXT_RECONCILIATION_STATUS + id + '/';
    return this.makeRequest(endpoint, ApiMethod.GET);
  }

  getResolutionType() {
    let endpoint: any = Endpoints.GET_RESOLUTION_TYPE;
    return this.makeRequest(endpoint, ApiMethod.GET);
  }
  
  getResolutionIssueType() {
    let endpoint: any = Endpoints.GET_RESOLUTION_ISSUE_TYPE;
    return this.makeRequest(endpoint, ApiMethod.GET);
  }

  getResolutionStatus() {
    let endpoint: any = Endpoints.GET_RESOLUTION_STATUS;
    return this.makeRequest(endpoint, ApiMethod.GET);
  }

  updateReconciliationStatus(id: any, formData: any) {
    let endpoint: any = `${Endpoints.UPDATE_RECONCILIATION_STATUS}${id}/`;
    return this._http.requestCall(endpoint, ApiMethod.PUT, formData, {
      observe: 'response',
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}
